import { memo } from 'react'
import type { AssetPresenceEntry } from '../../types/index.js'
import './MissingFileBadge.css'

/**
 * Signale qu'une donnée n'a plus de fichier derrière elle.
 *
 * Ne rend rien quand le fichier est présent, ou quand la présence n'est pas
 * établissable (`presence` absent : chemin vide, entrée DECKLINK, flux réseau,
 * ou entité pas encore passée au scanner). Un badge affiché doit toujours
 * vouloir dire quelque chose.
 */
export const MissingFileBadge = memo(function MissingFileBadge({ presence }: {
  presence: AssetPresenceEntry | null | undefined
}) {
  if (!presence || presence.status === 'PRESENT') return null

  const unknown = presence.status === 'UNKNOWN'
  return (
    <span
      className={`missing-file-badge${unknown ? ' missing-file-badge--unknown' : ''}`}
      title={unknown
        ? `Stockage inaccessible — impossible de vérifier ${presence.expectedPath}`
        : `Fichier introuvable : ${presence.expectedPath}`}
    >
      {unknown ? 'Non vérifié' : 'Fichier absent'}
    </span>
  )
})
